import CustomSelect from "Components/CommonComponents/CustomSelect";
import React from "react";

interface IcourseDetails {
  packageDeatils?: any;
  selectedPackage?: any;
  setselectedPackage?: any;
  handleSelectedPackage?: any;
}
function EnagagementReportMain({
  packageDeatils,
  selectedPackage,
  setselectedPackage,
  handleSelectedPackage,
}: IcourseDetails) {
  console.log(packageDeatils, selectedPackage, "Select Package");
  return (
    <>
      <div className="d-flex flex-column">
        <CustomSelect
          width={"100%"}
          height={"48px"}
          top={"-3px"}
          placeholder="Select Package"
          options={packageDeatils}
          isSearchable={false}
          menuPlacement="bottom"
          isClearable={false}
          iconInvalueContainer={true}
          menuShouldScrollIntoView={true}
          closeMenuOnSelect={true}
          onChange={(selected: any) => {
            setselectedPackage(selected);
            handleSelectedPackage(selected);
            console.log("stream", selected);
          }}
          value={selectedPackage}
        ></CustomSelect>
      </div>
    </>
  );
}

export default EnagagementReportMain;
